import { render, staticRenderFns } from "./PaginatorItem.vue?vue&type=template&id=22dfda9a"
import script from "./PaginatorItem.vue?vue&type=script&lang=js"
export * from "./PaginatorItem.vue?vue&type=script&lang=js"
import style0 from "./PaginatorItem.vue?vue&type=style&index=0&id=22dfda9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports